import { cn } from "@tosize/ui";
import type { ClassValue } from "clsx";
import type { FC, JSX } from "react";
import styles from "./ButtonGroup.module.css";

type HTMLButtonGroupProps = JSX.IntrinsicElements["div"];

interface ButtonGroupProps {
	spacing?: "none" | "small" | "medium" | "large";
	isAttached?: boolean;
}

const ButtonGroup: FC<ButtonGroupProps & HTMLButtonGroupProps> = (props) => {
	const { spacing = "medium", isAttached, className, children, ...remainingProps } = props;
	const spacingStyle: ClassValue = {
		"space-x-2": spacing === "small" && !isAttached,
		"space-x-4": spacing === "medium" && !isAttached,
		"space-x-6": spacing === "large" && !isAttached,
	};

	const attachedStyle: ClassValue = {
		[styles.btnGroup as string]: isAttached,
	};

	return (
		<div className={cn(className, spacingStyle, attachedStyle, "flex")} {...remainingProps}>
			{children}
		</div>
	);
};

export default ButtonGroup;
